import { markUserDeletedInMock } from './users';

// Mock of the baja WRITE: simulate latency, then anonymize the shared users fixture, so a follow-up
// searchUsersByPhoneMock by the old phone returns the anonymized hit. A courier account's reason is
// handed on for its `deleted` line. Idempotent. No error-injection hook, like its write siblings:
// error-path component tests inject a failing fn directly via DI.
export async function deleteUserMock(
  id: string,
  _amazonExclusion: boolean,
  reason?: string,
): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  markUserDeletedInMock(id, reason);
}
